import HeroSection from '../components/sections/HeroSection';
import ImageSlider from '../components/sections/ImageSlider';
import StatsSection from '../components/sections/StatsSection';
import ProductsPreview from '../components/sections/ProductsPreview';
import WhyUsSection from '../components/sections/WhyUsSection';
import CTABanner from '../components/sections/CTABanner';

export default function HomePage() {
  return (
    <>
      <HeroSection />
      <StatsSection />
      <ProductsPreview />
      <ImageSlider />
      <WhyUsSection />
      <CTABanner />
    </>
  );
}
